export default "/_nuxt/47f29bd793d864bcf7d5349971ff21b4.svg";